var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseAlternate = function SvgCloseAlternate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m284.3 256 99-99c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0l-99 99-99-99c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l99 99-99 99c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0l99-99 99 99c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3z"
  })));
};
export default SvgCloseAlternate;